import { useCurrentUser } from '@artic/api-client';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  staticData: { section: 'Admin' },
  component: AdminLayout,
});

function AdminLayout() {
  const { user } = useCurrentUser();
  const isAdmin = user.email.endsWith('@artic.works') || user.email.endsWith('@trunk.works');

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Access Denied</h2>
        <p className="text-muted-foreground text-sm">
          Admin pages are only available to Artic team members.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
